import Controller from '../abstracts/Controller';
import 'scss-templates/t-folded-listing.scss';

export default class FoldedListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'GeneralComponentsComponent',
      'NewsletterComponent',
      'ShowPasswordComponent',
      'SimpleBarComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'SeoTextComponent'
    ];
  }
}
